import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./toursList.css";
import { Link, NavLink } from "react-router-dom";
import tours from "../../../datebase/tours";
const ToursList = ({ t, langcat, setScoreTours, scoreTours }) => {

    return (
        <>
            <div className="toursList">
                <div className="containerToursList">
                    <div className="toursList-flex">
                        <div className="toursList-category">
                            <div className="toursList-categoryname ">
                                Горящие направления
                            </div>
                            <div className="toursList-category-grid">
                                {tours.map((koks) => {
                                    if (koks.category1 == "Top" && koks.tourlang === langcat) {
                                        return (
                                            <>
                                                <Link
                                                    className="link"
                                                    to={`/tours/${koks.id}`}
                                                >
                                                    <div className="toursList-category-grid-block">
                                                        <img src={`/${koks.img[0]}.jpg`} alt="" />
                                                        <span className="toursList-category-grid-block-textName">
                                                            {koks.name}
                                                        </span>
                                                        <span className="toursList-category-grid-block-textTime">
                                                            {koks.dayDuration}
                                                        </span>
                                                    </div>
                                                </Link>
                                            </>
                                        )
                                    }
                                })
                                }
                            </div>
                        </div>
                        <div className="toursList-category">
                            <div className="toursList-categoryname">
                                Aral Sea
                            </div>
                            <div className="toursList-category-grid">
                                {tours.map((koks) => {
                                    if (koks.category == "Aral" && koks.tourlang === langcat) {
                                        return (
                                            <>
                                                <Link
                                                    className="link"
                                                    to={`/tours/${koks.id}`}
                                                >
                                                    <div className="toursList-category-grid-block">
                                                        <img src={`/${koks.img[0]}.jpg`} alt="" />
                                                        <span className="toursList-category-grid-block-textName">
                                                            {koks.name}
                                                        </span>
                                                        <span className="toursList-category-grid-block-textTime">
                                                            {koks.dayDuration}
                                                        </span>
                                                    </div>
                                                </Link>
                                            </>
                                        )
                                    }
                                })
                                }
                            </div>
                        </div>
                        <div className="toursList-category">
                            <div className="toursList-categoryname">
                                Khiva
                            </div>
                            <div className="toursList-category-grid">
                                {tours.map((koks) => {
                                    if (koks.category == "Khiva" && koks.tourlang === langcat) {
                                        return (
                                            <>
                                                <Link
                                                    className="link"
                                                    to={`/tours/${koks.id}`}
                                                >
                                                    <div className="toursList-category-grid-block">
                                                        <img src={`/${koks.img[0]}.jpg`} alt="" />
                                                        <span className="toursList-category-grid-block-textName">
                                                            {koks.name}
                                                        </span>
                                                        <span className="toursList-category-grid-block-textTime">
                                                            {koks.dayDuration}
                                                        </span>
                                                    </div>
                                                </Link>
                                            </>
                                        )
                                    }
                                })
                                }
                            </div>
                        </div>
                        <div className="toursList-category">
                            <div className="toursList-categoryname">
                                Nukus
                            </div>
                            <div className="toursList-category-grid">
                                {tours.map((koks) => {
                                    if (koks.category == "Nukus" && koks.tourlang === langcat) {
                                        return (
                                            <>
                                                <Link
                                                    className="link"
                                                    to={`/tours/${koks.id}`}
                                                >
                                                    <div className="toursList-category-grid-block">
                                                        <img src={`/${koks.img[0]}.jpg`} alt="" />
                                                        <span className="toursList-category-grid-block-textName">
                                                            {koks.name}
                                                        </span>
                                                        <span className="toursList-category-grid-block-textTime">
                                                            {koks.dayDuration}
                                                        </span>
                                                    </div>
                                                </Link>
                                            </>
                                        )
                                    }
                                })
                                }
                            </div>
                        </div>
                        <div className="toursList-category">
                            <div className="toursList-categoryname">
                                Chimbay
                            </div>
                            <div className="toursList-category-grid">
                                {tours.map((koks) => {
                                    if (koks.category == "Chimbay" && koks.tourlang === langcat) {
                                        return (
                                            <>
                                                <Link
                                                    className="link"
                                                    to={`/tours/${koks.id}`}
                                                >
                                                    <div className="toursList-category-grid-block">
                                                        <img src={`/${koks.img[0]}.jpg`} alt="" />
                                                        <span className="toursList-category-grid-block-textName">
                                                            {koks.name}
                                                        </span>
                                                        <span className="toursList-category-grid-block-textTime">
                                                            {koks.dayDuration}
                                                        </span>
                                                    </div>
                                                </Link>
                                            </>
                                        )
                                    }
                                })
                                }
                            </div>
                        </div>
                        <div className="whyusSection">
                            <div className="whyusGrid">
                                <div className="whyusCard">
                                    <div className="whyusCardTop">150 000+</div>
                                    <div className="whyusCardSub">{t("whyus.cards.card1.sub")}</div>
                                    <h4>{t("whyus.cards.card1.title")}</h4>
                                    <p>{t("whyus.cards.card1.desc")}</p>
                                </div>

                                <div className="whyusCard">
                                    <div className="whyusCardTop">№1</div>
                                    <div className="whyusCardSub">{t("whyus.cards.card2.sub")}</div>
                                    <h4>{t("whyus.cards.card2.title")}</h4>
                                    <p>{t("whyus.cards.card2.desc")}</p>
                                </div>

                                <div className="whyusCard">
                                    <div className="whyusCardTop">20+</div>
                                    <div className="whyusCardSub">{t("whyus.cards.card3.sub")}</div>
                                    <h4>{t("whyus.cards.card3.title")}</h4>
                                    <p>{t("whyus.cards.card3.desc")}</p>
                                </div>

                                <div className="whyusCard">
                                    <div className="whyusCardTop">0 $</div>
                                    <div className="whyusCardSub">{t("whyus.cards.card4.sub")}</div>
                                    <h4>{t("whyus.cards.card4.title")}</h4>
                                    <p>{t("whyus.cards.card4.desc")}</p>
                                </div>

                                <div className="whyusCard">
                                    <div className="whyusCardTop">{t("whyus.cards.card5.zag")}</div>
                                    <div className="whyusCardSub">{t("whyus.cards.card5.sub")}</div>
                                    <h4>{t("whyus.cards.card5.title")}</h4>
                                    <p>{t("whyus.cards.card5.desc")}</p>
                                </div>

                                <div className="whyusCard">
                                    <div className="whyusCardTop">100%</div>
                                    <div className="whyusCardSub">{t("whyus.cards.card6.sub")}</div>
                                    <h4>{t("whyus.cards.card6.title")}</h4>
                                    <p>{t("whyus.cards.card6.desc")}</p>
                                </div>
                            </div>

                            <div className="whyusCharity">
                                <div className="whyusCharityBadge">{t("whyus.charity.badge")}</div>
                                <h3>{t("whyus.charity.title")}</h3>
                                <p>{t("whyus.charity.desc")}</p>

                                <div className="whyusCharityBottom">
                                    <div className="whyusCharityPercent">2%</div>
                                    <div className="whyusCharityNote">{t("whyus.charity.note")}</div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="toursList-whyus">
                            <div className="toursList-whyus-text">
                                <h5>{t("toursList-whyuszag")}</h5>
                            </div>
                            <div className="toursList-whyus-flex">
                                <div className="toursList-whyus-boxs">
                                    <span className="toursList-whyus-boxs-icon"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span>
                                    <span className="toursList-whyus-boxs-texts">
                                        <h5>{t("toursList-whyus.text1-1")}</h5>
                                        <h6>{t("toursList-whyus.text1-2")}</h6>
                                    </span>
                                </div>
                                <div className="toursList-whyus-boxs">
                                    <span className="toursList-whyus-boxs-icon"><i class="fa fa-bars" aria-hidden="true"></i></span>
                                    <span className="toursList-whyus-boxs-texts">
                                        <h5>{t("toursList-whyus.text2-1")}</h5>
                                        <h6>{t("toursList-whyus.text2-2")}</h6>
                                    </span>
                                </div>
                                <div className="toursList-whyus-boxs">
                                    <span className="toursList-whyus-boxs-icon"><i class="fa fa-lock" aria-hidden="true"></i></span>
                                    <span className="toursList-whyus-boxs-texts">
                                        <h5>{t("toursList-whyus.text3-1")}</h5>
                                        <h6>{t("toursList-whyus.text3-2")}</h6>
                                    </span>
                                </div>
                                <div className="toursList-whyus-boxs">
                                    <span className="toursList-whyus-boxs-icon"><i class="fa fa-credit-card-alt" aria-hidden="true"></i></span>
                                    <span className="toursList-whyus-boxs-texts">
                                        <h5>{t("toursList-whyus.text4-1")}</h5>
                                        <h6>{t("toursList-whyus.text4-2")}</h6>
                                    </span>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    );
};
export default ToursList;
